module.exports = __webpack_public_path__ + "img/kefu.184771c.svg";